import { useState, useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { authService } from '../services/auth'
import MarketingHeader from '../components/MarketingHeader'
import './ConfirmEmailChangePage.scss'

const ConfirmEmailChangePage = () => {
  const { t } = useTranslation(['auth', 'common'])
  const [searchParams] = useSearchParams()

  const token = searchParams.get('token')
  const email = searchParams.get('email')

  // UI state
  const [confirming, setConfirming] = useState(false)
  const [confirmed, setConfirmed] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!token || !email) return

    const confirm = async () => {
      setConfirming(true)
      setError('')

      try {
        await authService.confirmEmailChange(token, email)
        setConfirmed(true)
      } catch (err) {
        const code = err.response?.data?.code

        if (code === 'TOKEN_EXPIRED') {
          setError(t('auth:changeEmail.linkExpired'))
        } else {
          setError(err.response?.data?.error || t('auth:changeEmail.confirmFailed'))
        }
      } finally {
        setConfirming(false)
      }
    }

    confirm()
  }, [token, email, t])

  // No token or email in URL
  if (!token || !email) {
    return (
      <div className="confirm-email-change-page">
        <MarketingHeader />
        <div className="confirm-email-change-page__card">
          <h1 className="confirm-email-change-page__title">{t('auth:changeEmail.title')}</h1>
          <div className="confirm-email-change-page__message confirm-email-change-page__message--error">
            <p>{t('auth:changeEmail.invalidLink')}</p>
          </div>
          <div className="confirm-email-change-page__links">
            <Link to="/login">{t('auth:changeEmail.goToLogin')}</Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="confirm-email-change-page">
      <MarketingHeader />
      <div className="confirm-email-change-page__card">
        <h1 className="confirm-email-change-page__title">{t('auth:changeEmail.title')}</h1>

        {/* Loading state */}
        {confirming && (
          <div className="confirm-email-change-page__message confirm-email-change-page__message--loading">
            <p>{t('auth:changeEmail.confirmTitle')}</p>
          </div>
        )}

        {/* Success state */}
        {confirmed && (
          <>
            <div className="confirm-email-change-page__message confirm-email-change-page__message--success">
              <p>{t('auth:changeEmail.confirmSuccess')}</p>
            </div>
            <Link to="/login" className="confirm-email-change-page__button confirm-email-change-page__button--primary">
              {t('auth:changeEmail.signIn')}
            </Link>
          </>
        )}

        {/* Error state */}
        {!confirming && error && (
          <>
            <div className="confirm-email-change-page__message confirm-email-change-page__message--error">
              <p>{error}</p>
            </div>
            <div className="confirm-email-change-page__links">
              <Link to="/login">{t('auth:changeEmail.goToLogin')}</Link>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default ConfirmEmailChangePage
